module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.png")
    }
  }), _vm._v(" "), _c('h1', [_vm._v("stf-vue-select - the most flexible vue select")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Select without input")]), _vm._v(" "), _c('stf-select', {
    staticStyle: {
      "width": "300px",
      "margin": "0 auto"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Input address")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "value"
    },
    slot: "value"
  }, [(_vm.value) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.value.address) + " ("), _c('small', [_vm._v(_vm._s(_vm.value.text))]), _vm._v(")")])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "options delivery_order__options"
  }, _vm._l((_vm.list), function(item) {
    return _c('stf-select-option', {
      key: item.id,
      class: {
        'stf-select-option_selected': item.id === (_vm.value && _vm.value.id)
      },
      attrs: {
        "value": item
      }
    }, [_c('span', [_vm._v(_vm._s(item.text) + " ("), _c('small', [_vm._v(_vm._s(item.address))]), _vm._v(")")])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("Select with input")]), _vm._v(" "), _c('stf-select', {
    staticStyle: {
      "width": "300px",
      "margin": "0 auto"
    },
    attrs: {
      "needFocusInpOnTab": true
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('div', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Input address")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "value"
    },
    slot: "value"
  }, [(_vm.value) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.value.address) + " ("), _c('small', [_vm._v(_vm._s(_vm.value.text))]), _vm._v(")")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "search-input"
    },
    slot: "search-input"
  }, [_c('input', {
    staticClass: "stf-select__search-input",
    attrs: {
      "placeholder": "Input address"
    },
    on: {
      "input": _vm.onsearch
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "options delivery_order__options"
  }, _vm._l((_vm.listFinded), function(item) {
    return _c('stf-select-option', {
      key: item.id,
      class: {
        'stf-select-option_selected': item.id === (_vm.value && _vm.value.id)
      },
      attrs: {
        "value": item
      }
    }, [_c('span', [_vm._v(_vm._s(item.text) + " ("), _c('small', [_vm._v(_vm._s(item.address))]), _vm._v(")")])])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46d49320"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 105
// module chunks = 2